/**
 * Filters routes based on CRM_PAGES_DISABLED environment variable
 * When CRM_PAGES_DISABLED is set to '1', certain pages are hidden
 */
export const filterRoutes = (routes) => {
  const isPagesDisabled = process.env.REACT_APP_CRM_PAGES_DISABLED === '1';

  console.log('isPagesDisabled', isPagesDisabled);
  if (!isPagesDisabled) {
    return routes;
  }

  // Filter routes without deep cloning (to preserve React components)
  // We'll create new objects but keep references to React components
  return routes
    .map((route) => {
      // Remove entire Stock Management section
      if (route.key === 'stockManagement') {
        return null;
      }

      // Filter Finance section
      if (route.key === 'finance') {
        const filteredRoute = { ...route };
        if (route.content) {
          filteredRoute.content = route.content.filter((item) => {
            // Remove finance-reports
            if (item.route === '/finance-reports') {
              return false;
            }
            return true;
          });
        }
        if (route.routes) {
          filteredRoute.routes = route.routes.filter((r) => r !== '/finance-reports');
        }
        if (route.accessChilds) {
          filteredRoute.accessChilds = route.accessChilds.filter(
            (a) => a !== 'getFinanceReports'
          );
        }
        return filteredRoute;
      }

      // Filter Sales section
      if (route.key === 'salesTeam') {
        const filteredRoute = { ...route };
        if (route.content) {
          filteredRoute.content = route.content.filter((item) => {
            // Remove sales-reports
            if (item.route === '/sales-reports') {
              return false;
            }
            return true;
          });
        }
        if (route.routes) {
          filteredRoute.routes = route.routes.filter((r) => r !== '/sales-reports');
        }
        if (route.accessChilds) {
          filteredRoute.accessChilds = route.accessChilds.filter(
            (a) => a !== 'getSalesReports'
          );
        }
        return filteredRoute;
      }

      // Filter Support Team section
      if (route.key === 'supportTeam') {
        const filteredRoute = { ...route };
        if (route.content) {
          filteredRoute.content = route.content.map((item) => {
            const filteredItem = { ...item };
            if (item.content) {
              filteredItem.content = item.content.filter((subItem) => {
                // Remove knowledge-base
                if (subItem.route === '/knowledge-base') {
                  return false;
                }
                return true;
              });
            }
            if (item.routes) {
              filteredItem.routes = item.routes.filter((r) => r !== '/knowledge-base');
            }
            if (item.accessChilds) {
              filteredItem.accessChilds = item.accessChilds.filter(
                (a) => a !== 'getKnowledgeBases'
              );
            }
            return filteredItem;
          });
        }
        if (route.routes) {
          filteredRoute.routes = route.routes.filter((r) => r !== '/knowledge-base');
        }
        if (route.accessChilds) {
          filteredRoute.accessChilds = route.accessChilds.filter(
            (a) => a !== 'getKnowledgeBases'
          );
        }
        return filteredRoute;
      }

      // Filter Products section
      if (route.key === 'products') {
        const filteredRoute = { ...route };
        if (route.content) {
          filteredRoute.content = route.content.map((item) => {
            const filteredItem = { ...item };
            if (item.content) {
              filteredItem.content = item.content.filter((subItem) => {
                // Remove product-tags
                if (subItem.route === '/product-tags') {
                  return false;
                }
                return true;
              });
            }
            if (item.routes) {
              filteredItem.routes = item.routes.filter((r) => r !== '/product-tags');
            }
            if (item.accessChilds) {
              filteredItem.accessChilds = item.accessChilds.filter(
                (a) => a !== 'getProductTags'
              );
            }
            return filteredItem;
          });
        }
        if (route.routes) {
          filteredRoute.routes = route.routes.filter((r) => r !== '/product-tags');
        }
        if (route.accessChilds) {
          filteredRoute.accessChilds = route.accessChilds.filter(
            (a) => a !== 'getProductTags'
          );
        }
        return filteredRoute;
      }

      // Filter Settings section - show only Automations when CRM_PAGES_DISABLED is set
      if (route.key === 'settings') {
        const filteredRoute = { ...route };
        if (route.content) {
          // Keep only Automations
          filteredRoute.content = route.content.filter((item) => {
            return item.key === 'automations';
          });
        }
        if (route.routes) {
          // Keep only automations route
          filteredRoute.routes = route.routes.filter((r) => r === '/automations');
        }
        if (route.accessChilds) {
          // Keep only getAutomations permission
          filteredRoute.accessChilds = route.accessChilds.filter(
            (a) => a === 'getAutomations'
          );
        }
        return filteredRoute;
      }

      return route;
    })
    .filter((route) => route !== null);
};

